module.exports = __webpack_public_path__ + "static/media/OpenSansHebrew-ExtraBold.612a3556.ttf";